import React, { useState } from "react";
import "./Storeview.css";
import { FaToggleOn, FaToggleOff, FaEye } from "react-icons/fa";
import { BsPlusCircleDotted } from "react-icons/bs";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useStoreView } from "../../customHooks/StoreView/useStoreView";
import { FiEdit, FiUpload, FiExternalLink } from "react-icons/fi";
import ReactSlider from "react-slider";
import { useToasts } from "react-toast-notifications";

import ServicabilitySettings from "../ServicabilitySettings/ServicabilitySettings";
import usePermission from "../../utils/usePermission";
import UnAuthorized from "../UnAuthorized/UnAuthorized";
import { color } from "@amcharts/amcharts4/core";

const StoreView = () => {
  const today = new Date().toISOString().slice(0, 10);
  const talonProps = useStoreView();
  const {
    storeDetails,
    setStoreDetails,
    activeTab,
    setActiveTab,
    // setActiveTab: handleTabSwitch,
    // isTabDisabled,
    storeImages,
    storeImagesLength,
    fetchData,
    addInputField,
    removeInputField,
    handleImageChange,
    handleUpdateClick,
    handleStoreLogoChange,
    handleAddressChange,
    handleStoreSettings,
    handleServiceabilityDetails,
    handleBusinessDetails,
    handleBankDetails,
    handleCustomerSupport,
    handleFormSubmit,
    handleBlur,
    handleStoreDetailChange,
    renderErrorMessage,
    errors,
    handleGroProfileImageChange,
    isTabDisabled,
  } = talonProps;

  const canViewSettings = usePermission("SETTINGS_VIEW");
  const canEditSettings = usePermission("SETTINGS_EDIT");

  const { addToast } = useToasts();
  const logoSymbol = storeDetails.StoreDetails.bpp_symbol;

  const logoUrl =
    typeof logoSymbol === "string"
      ? logoSymbol
      : logoSymbol instanceof File
        ? URL.createObjectURL(logoSymbol)
        : "";

  const fileName =
    typeof logoSymbol === "string"
      ? logoSymbol.split("/").pop()
      : logoSymbol instanceof File
        ? logoSymbol.name
        : "";

  const formatTabName = (tab) => {
    return tab.replace(/([a-z])([A-Z])/g, "$1 $2");
  };

  const renderTabContent = () => {
    // if (!canEditSettings) {
    //   return <UnAuthorized />;
    // }
    switch (activeTab) {
      case "StoreDetails":
        return (
          <>
            {storeDetails["StoreDetails"] && (
              <div className="profile-section">
                <h5 className="storetitle pt-2">Store Details</h5>
                <div className="row borderup">
                  <div className="col-2">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                      }}
                    >
                      <label>Store Active/In Active</label>
                      <span
                        className="toggleBtn"
                        onClick={() => {
                          const updatedStoreDetails = {
                            ...storeDetails,
                            StoreDetails: {
                              ...storeDetails.StoreDetails,
                              store_active:
                                !storeDetails.StoreDetails.store_active,
                            },
                          };
                          setStoreDetails(updatedStoreDetails);
                          handleBlur(
                            "StoreDetails",
                            "store_active",
                            updatedStoreDetails.StoreDetails.store_active,
                          );
                        }}
                      >
                        {storeDetails.StoreDetails.store_active ? (
                          <FaToggleOn size={30} color={"green"} />
                        ) : (
                          <FaToggleOff size={30} color={"#cd3e3e"} />
                        )}
                      </span>
                    </div>
                    <div className="text-left text-small color_red inputErrorSection">
                      {renderErrorMessage("store_active")}
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-group">
                      <label>Store Title</label>
                      <input
                        type="text"
                        name="bpp_name"
                        value={storeDetails.StoreDetails.bpp_name || ""}
                        onChange={(e) =>
                          handleStoreDetailChange(
                            "StoreDetails",
                            "bpp_name",
                            e.target.value,
                          )
                        }
                        onBlur={() =>
                          handleBlur(
                            "StoreDetails",
                            "bpp_name",
                            storeDetails.StoreDetails.bpp_name,
                          )
                        }
                      />
                      <div className="input-hint">
                        {`Enter a unique name for the store.`}
                      </div>
                      <div className="text-left text-small color_red inputErrorSection">
                        {renderErrorMessage("bpp_name")}
                      </div>
                    </div>
                  </div>

                  <div className="col-5">
                    <div className="form-group">
                      <label>Store Timings</label>

                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          {" "}
                          <input
                            type="time"
                            value={
                              storeDetails.StoreDetails.store_opening_time || ""
                            }
                            onChange={(e) =>
                              handleStoreDetailChange(
                                "StoreDetails",
                                "store_opening_time",
                                e.target.value,
                              )
                            }
                            onBlur={() =>
                              handleBlur(
                                "StoreDetails",
                                "store_opening_time",
                                storeDetails.StoreDetails.store_opening_time,
                              )
                            }
                          />
                          <div className="text-left text-small color_red inputErrorSection">
                            {renderErrorMessage("store_opening_time")}
                          </div>
                        </div>

                        <span>to</span>
                        <div>
                          {" "}
                          <input
                            type="time"
                            value={
                              storeDetails.StoreDetails.store_closing_time || ""
                            }
                            onChange={(e) =>
                              handleStoreDetailChange(
                                "StoreDetails",
                                "store_closing_time",
                                e.target.value,
                              )
                            }
                            onBlur={() =>
                              handleBlur(
                                "StoreDetails",
                                "store_closing_time",
                                storeDetails.StoreDetails.store_closing_time,
                              )
                            }
                          />
                          <div className="text-left text-small color_red inputErrorSection">
                            {renderErrorMessage("store_closing_time")}
                          </div>
                        </div>
                      </div>

                      <div className="input-hint">
                        {`Set the opening and closing time for the store.`}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row align-items-center">
                  {/* Logo Section */}
                  <div className="col-2 form-group">
                    <label>Logo</label>
                    <div className="storeLogo">
                      {logoUrl ? (
                        <div className="logoContainer">
                          <img
                            src={
                              logoUrl instanceof File
                                ? URL.createObjectURL(logoUrl)
                                : logoUrl
                            }
                            alt="Store Logo"
                            className="logoImage"
                            onLoad={(e) => {
                              if (logoUrl instanceof File) {
                                URL.revokeObjectURL(e.target.src);
                              }
                            }}
                          />
                          <div className="logoEditAction">
                            <FiEdit
                              title="Edit Logo"
                              style={{
                                cursor: "pointer",
                                fontSize: "20px",
                                color: "black",
                              }}
                              onClick={() =>
                                document
                                  .getElementById("storeLogoInput")
                                  .click()
                              }
                            />
                          </div>
                        </div>
                      ) : (
                        <div
                          className="placeholderLogo"
                          onClick={() =>
                            document.getElementById("storeLogoInput").click()
                          }
                        >
                          <FiUpload
                            style={{
                              cursor: "pointer",
                              fontSize: "24px",
                              color: "#007bff",
                            }}
                          />
                        </div>
                      )}
                      <input
                        type="file"
                        name="bpp_symbol"
                        id="storeLogoInput"
                        accept="image/jpeg, image/png, image/jpg, image/webp"
                        style={{ display: "none" }}
                        onChange={(e) =>
                          handleStoreLogoChange(e.target.files[0])
                        }
                      />
                    </div>
                    <div className="input-hint">{`Upload a valid logo image.`}</div>
                    <div className="text-left text-small color_red inputErrorSection">
                      {renderErrorMessage("bpp_symbol")}
                    </div>
                  </div>

                  {/* Store Images Section */}
                  <div className="col-9 form-group">
                    <label>Store Images</label>
                    <div className="storeimg">
                      <div className="imgfield">
                        <div className="image-grid">
                          {storeImages?.map((value, index) => {
                            const isFileBuffer = value instanceof File;

                            return (
                              <div key={index} className="imagesFields">
                                <img
                                  src={
                                    isFileBuffer
                                      ? URL.createObjectURL(value)
                                      : value
                                  }
                                  className="imagesFieldsImage"
                                  alt={`storeImage-${index}`}
                                  onLoad={(e) => {
                                    if (isFileBuffer) {
                                      URL.revokeObjectURL(e.target.src);
                                    }
                                  }}
                                />
                                <div className="ImageFieldsActions">
                                  <span>
                                    <RiDeleteBin6Line
                                      style={{
                                        cursor: "pointer",
                                        color: "red",
                                        fontSize: "20px",
                                      }}
                                      title="Remove Image"
                                      onClick={() => removeInputField(index)}
                                    />
                                  </span>
                                </div>
                                {errors[index] && (
                                  <div className="text-left text-small color_red inputErrorSection">
                                    {errors[index]}
                                  </div>
                                )}
                              </div>
                            );
                          })}

                          <div className="newStoreImageUpload">
                            <input
                              type="file"
                              id={`imageInputNew`}
                              style={{ display: "none" }}
                              accept="image/jpeg, image/png, image/jpg, image/webp"
                              onChange={(e) =>
                                handleImageChange(e.target.files[0])
                              }
                              disabled={storeImages.length >= 6}
                            />
                            <FiUpload
                              onClick={() => handleUpdateClick()}
                              disabled={storeImages.length >= 6}
                              style={{ color: storeImages.length >= 6 ? "grey" : "#007bff", cursor: storeImages.length <6 ?"pointer":"none", fontSize:"24px" }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="input-hint">
                      <p>
                        Upload store images one by one. You must upload the
                        current image before adding a new one.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <label style={{ marginTop: "10px" }}>
                        Short Description
                      </label>
                      <input
                        type="text"
                        name="bpp_short_desc"
                        value={storeDetails.StoreDetails.bpp_short_desc || ""}
                        onChange={(e) =>
                          handleStoreDetailChange(
                            "StoreDetails",
                            "bpp_short_desc",
                            e.target.value,
                          )
                        }
                        onBlur={() =>
                          handleBlur(
                            "StoreDetails",
                            "bpp_short_desc",
                            storeDetails.StoreDetails.bpp_short_desc,
                          )
                        }
                      />
                      <div className="input-hint">
                        {`Provide a brief description of your store.(10-255 characters)`}
                      </div>
                      <div className="text-left text-small color_red inputErrorSection">
                        {renderErrorMessage("bpp_short_desc")}
                      </div>
                    </div>
                    <div className="form-group">
                      <label style={{ marginTop: "17px" }}>
                        Long Description
                      </label>
                      <textarea
                        name="bpp_long_desc"
                        rows="3"
                        cols="50"
                        value={storeDetails.StoreDetails.bpp_long_desc || ""}
                        onChange={(e) =>
                          handleStoreDetailChange(
                            "StoreDetails",
                            "bpp_long_desc",
                            e.target.value,
                          )
                        }
                        onBlur={() =>
                          handleBlur(
                            "StoreDetails",
                            "bpp_long_desc",
                            storeDetails.StoreDetails.bpp_long_desc,
                          )
                        }
                      />
                      <div className="input-hint">
                        {`Provide a detailed description of your store.(20-1000 characters)`}
                      </div>
                      <div className="text-left text-small color_red inputErrorSection">
                        {renderErrorMessage("bpp_long_desc")}
                      </div>
                    </div>
                  </div>
                </div>

                <h6 className="storeinfo" style={{ marginTop: "16px" }}>
                  Address
                </h6>
                <div className="addressstore">
                  <div className="row">
                    {[
                      "locality",
                      "street",
                      "city",
                      "state",
                      "area_code",
                      "latitude",
                      "longitude",
                    ].map((field, idx) => (
                      <div key={idx} className="col-3">
                        <div className="form-group">
                          <label>
                            {field.charAt(0).toUpperCase() +
                              field.slice(1).replace("_", " ")}
                          </label>
                          <input
                            type="text"
                            value={
                              storeDetails.StoreDetails.store_address?.[
                                field
                              ] || ""
                            }
                            onChange={(e) =>
                              handleAddressChange(
                                "StoreDetails",
                                field,
                                e.target.value,
                              )
                            }
                            onBlur={(e) =>
                              handleBlur(
                                "StoreDetails",
                                `store_address.${field}`,
                                e.target.value,
                              )
                            }
                          />
                          <div className="input-hint">
                            {`Provide the ${field.replace(
                              "_",
                              " ",
                            )} for your store.`}
                          </div>
                          <div className="text-left text-small color_red inputErrorSection">
                            {renderErrorMessage(`store_address.${field}`)}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <h6 className="storeinfo mt-3">Contact Information</h6>
                <div className="addressstore">
                  <div className="row">
                    <div className="col-3">
                      <div className="form-group">
                        <label>Store Email</label>
                        <input
                          name="store_email"
                          type="text"
                          value={storeDetails.StoreDetails.store_email || ""}
                          onChange={(e) =>
                            handleStoreDetailChange(
                              "StoreDetails",
                              "store_email",
                              e.target.value,
                            )
                          }
                          onBlur={() =>
                            handleBlur(
                              "StoreDetails",
                              "store_email",
                              storeDetails.StoreDetails.store_email,
                            )
                          }
                        />
                        <div className="input-hint">
                          {`Enter a valid email address for your store.(e.g., support@example.com)`}
                        </div>
                        <div className="text-left text-small color_red inputErrorSection">
                          {renderErrorMessage("store_email")}
                        </div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-group">
                        <label>Store Contact No.</label>
                        <input
                          type="text"
                          name="store_phone_number"
                          value={
                            storeDetails.StoreDetails.store_phone_number || ""
                          }
                          onChange={(e) =>
                            handleStoreDetailChange(
                              "StoreDetails",
                              "store_phone_number",
                              e.target.value,
                            )
                          }
                          onBlur={() =>
                            handleBlur(
                              "StoreDetails",
                              "store_phone_number",
                              storeDetails.StoreDetails.store_phone_number,
                            )
                          }
                        />
                        <div className="input-hint">
                          {`Enter a valid 10 digit contact number(e.g., 9234567890).`}
                        </div>
                        <div className="text-left text-small color_red inputErrorSection">
                          {renderErrorMessage("store_phone_number")}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        );

      case "StoreSettings":
        return (
          <>
            {storeDetails["StoreSettings"] && (
              <div className="profile-section">
                <div className="row">
                  <div className="col-12">
                    <h5 className="storetitle pt-2">Store Settings</h5>
                  </div>
                </div>

                <div className="row borderup">
                  <div className="col-4">
                    <div className="form-group">
                      <label>
                        {" "}
                        Buyer Commission Range &nbsp; ({" "}
                        {storeDetails.StoreSettings?.buyer_finder_fee_min || 0}-
                        {storeDetails.StoreSettings?.buyer_finder_fee_max})%
                      </label>
                      <div style={{ marginTop: "10px" }}>
                        <ReactSlider
                          className="horizontal-slider"
                          thumbClassName="slider-thumb"
                          trackClassName="slider-track"
                          value={[
                            storeDetails.StoreSettings?.buyer_finder_fee_min ||
                              0,
                            storeDetails.StoreSettings?.buyer_finder_fee_max ||
                              100,
                          ]}
                          onChange={(values) => {
                            handleStoreSettings(
                              "StoreSettings",
                              "buyer_finder_fee_min",
                              values[0],
                            );
                            handleStoreSettings(
                              "StoreSettings",
                              "buyer_finder_fee_max",
                              values[1],
                            );
                            handleBlur(
                              "StoreSettings",
                              "buyer_finder_fee_min",
                              values[0],
                            );
                            handleBlur(
                              "StoreSettings",
                              "buyer_finder_fee_max",
                              values[1],
                            );
                          }}
                          min={0}
                          max={100}
                          step={1}
                          pearling
                          renderThumb={(props, state) => (
                            <div {...props}>{state.valueNow}%</div>
                          )}
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginTop: "10px",
                          fontSize: "12px",
                        }}
                      >
                        <span style={{ color: "grey" }}>0%</span>
                        <span style={{ color: "grey" }}>100%</span>
                      </div>
                      <div className="input-hint">
                        Set a range between 0% to 100%.
                      </div>
                    </div>
                  </div>

                  {storeDetails.StoreSettings?.is_products_returnable && (
                    <div className="col-4">
                      <div className="form-group">
                        <label>Return Window Days</label>
                        <input
                          type="text"
                          name="return_window"
                          value={
                            storeDetails.StoreSettings?.return_window || ""
                          }
                          onChange={(e) => {
                            handleStoreSettings(
                              "StoreSettings",
                              "return_window",
                              e.target.value,
                            );
                            handleBlur(
                              "StoreSettings",
                              "return_window",
                              e.target.value,
                            );
                          }}
                        />
                        <div className="input-hint">
                          Set the number of days after which returns are no
                          longer accepted.
                        </div>
                        <div className="text-left text-small color_red inputErrorSection">
                          {renderErrorMessage("return_window")}
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="col-4">
                    <div className="form-group">
                      <label>Max Estimated Delivery Time</label>

                      <div className="input-group d-flex">
                        <input
                          type="text"
                          name="delivery_tat"
                          value={storeDetails.StoreSettings?.delivery_tat || ""}
                          onChange={(e) => {
                            handleStoreSettings(
                              "StoreSettings",
                              "delivery_tat",
                              e.target.value,
                            );
                            handleBlur(
                              "StoreSettings",
                              "delivery_tat",
                              e.target.value,
                            );
                          }}
                          className="form-control"
                        />
                        <input
                          className="form-control"
                          name="delivery_tat_unit"
                          value="Days"
                          disabled
                          readOnly
                        />
                      </div>
                      <div className="input-hint">
                        Enter the max delivery time in days.
                      </div>
                      <div className="text-left text-small color_red inputErrorSection">
                        {renderErrorMessage("delivery_tat")}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-3">
                    <div className="form-group togglebtnflex">
                      <label>Are Products Returnable?</label>
                      <div
                        className="toggleBtn"
                        onClick={() =>
                          handleStoreSettings(
                            "StoreSettings",
                            "is_products_returnable",
                            !storeDetails.StoreSettings?.is_products_returnable,
                          )
                        }
                      >
                        {storeDetails.StoreSettings?.is_products_returnable ? (
                          <FaToggleOn size={40} color={"green"} />
                        ) : (
                          <FaToggleOff size={40} color={"#cd3e3e"} />
                        )}
                      </div>
                    </div>
                    <div className="input-hint">
                      Toggle to enable or disable product returns.
                    </div>
                  </div>

                  <div className="col-3">
                    <div className="form-group togglebtnflex">
                      <label>Will Seller Pickup the Return?</label>
                      <div
                        className="toggleBtn"
                        onClick={() =>
                          handleStoreSettings(
                            "StoreSettings",
                            "is_seller_pickup_return",
                            !storeDetails.StoreSettings
                              ?.is_seller_pickup_return,
                          )
                        }
                      >
                        {storeDetails.StoreSettings?.is_seller_pickup_return ? (
                          <FaToggleOn size={40} color={"green"} />
                        ) : (
                          <FaToggleOff size={40} color={"#cd3e3e"} />
                        )}
                      </div>
                    </div>
                    <div className="input-hint">
                      Enable if seller is responsible for picking up returns.
                    </div>
                  </div>

                  <div className="col-3">
                    <div className="form-group togglebtnflex">
                      <label>Are Products Cancellable?</label>
                      <div
                        className="toggleBtn"
                        onClick={() =>
                          handleStoreSettings(
                            "StoreSettings",
                            "is_products_cancellable",
                            !storeDetails.StoreSettings
                              ?.is_products_cancellable,
                          )
                        }
                      >
                        {storeDetails.StoreSettings?.is_products_cancellable ? (
                          <FaToggleOn size={40} color={"green"} />
                        ) : (
                          <FaToggleOff size={40} color={"#cd3e3e"} />
                        )}
                      </div>
                    </div>
                    <div className="input-hint">
                      Enable to allow cancellations of products.
                    </div>
                  </div>

                  <div className="col-3">
                    <div className="form-group togglebtnflex">
                      <label>Is Tracking Enable?</label>
                      <div
                        className="toggleBtn"
                        onClick={() =>
                          handleStoreSettings(
                            "StoreSettings",
                            "is_tracking_available",
                            !storeDetails.StoreSettings?.is_tracking_available,
                          )
                        }
                      >
                        {storeDetails.StoreSettings?.is_tracking_available ? (
                          <FaToggleOn size={40} color={"green"} />
                        ) : (
                          <FaToggleOff size={40} color={"#cd3e3e"} />
                        )}
                      </div>
                    </div>
                    <div className="input-hint">
                      Enable this to allow order tracking.
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        );

      case "ServiceabilityAndDeliveryCharges":
        return (
          <>
            {storeDetails["ServiceabilityAndDeliveryCharges"] && (
              <div
                className="profile-section"
                style={{
                  maxHeight: "718px",
                  overflowY: "scroll",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >
                <div className="row" style={{ height: "100%" }}>
                  <ServicabilitySettings
                    storeDetails={storeDetails}
                    handleServiceabilityDetails={handleServiceabilityDetails}
                  />

                  <div className="row">
                    <div className="row align-items-center">
                      {storeDetails.ServiceabilityAndDeliveryCharges
                        ?.is_all_india_serviceable && (
                        <div className="col-3">
                          <div className="form-group">
                            <label>Delivery Charges per Order</label>
                            <input
                              type="text"
                              name="delivery_charges"
                              value={
                                storeDetails.ServiceabilityAndDeliveryCharges
                                  ?.delivery_charges !== undefined &&
                                storeDetails.ServiceabilityAndDeliveryCharges
                                  ?.delivery_charges !== null
                                  ? String(
                                      storeDetails
                                        .ServiceabilityAndDeliveryCharges
                                        .delivery_charges,
                                    )
                                  : ""
                              }
                              onChange={(e) =>
                                handleServiceabilityDetails(
                                  "ServiceabilityAndDeliveryCharges",
                                  "delivery_charges",
                                  e.target.value,
                                )
                              }
                              onBlur={(e) =>
                                handleBlur(
                                  "ServiceabilityAndDeliveryCharges",
                                  "delivery_charges",
                                  e.target.value,
                                )
                              }
                            />
                          </div>
                          <div className="input-hint">
                            Set the delivery charge per order (e.g., 50 or
                            75.5).
                          </div>
                          <div className="text-left text-small color_red inputErrorSection">
                            {/* {renderErrorMessage("delivery_charges")} */}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        );

      case "BusinessDetails":
        return (
          <>
            {storeDetails["BusinessDetails"] && (
              <div className="profile-section">
                <div className="row">
                  <div className="col-12">
                    <h5 class="storetitle pt-2">Business Details</h5>
                  </div>
                </div>
                <div className="row borderup">
                  <div className="col-3">
                    <div className="form-group">
                      <label>Authorized Person's Name</label>
                      <input
                        type="text"
                        name="authorised_signatory"
                        onChange={(e) =>
                          handleBusinessDetails(
                            "BusinessDetails",
                            "authorised_signatory",
                            e.target.value,
                          )
                        }
                        onBlur={() =>
                          handleBlur(
                            "BusinessDetails",
                            "authorised_signatory",
                            storeDetails.BusinessDetails.authorised_signatory,
                          )
                        }
                        value={
                          storeDetails.BusinessDetails.authorised_signatory ||
                          ""
                        }
                      />
                      <div className="text-left text-small text-muted input-hint">
                        Enter full name as per government ID
                      </div>
                      <div className="text-left text-small color_red inputErrorSection">
                        {renderErrorMessage("authorised_signatory")}
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group">
                      <label>Date of Incorporation</label>
                      <input
                        type="date"
                        name="date_of_incorporation"
                        onChange={(e) =>
                          handleBusinessDetails(
                            "BusinessDetails",
                            "date_of_incorporation",
                            e.target.value,
                          )
                        }
                        onBlur={() =>
                          handleBlur(
                            "BusinessDetails",
                            "date_of_incorporation",
                            storeDetails.BusinessDetails.date_of_incorporation,
                          )
                        }
                        max={today}
                        value={
                          storeDetails.BusinessDetails?.date_of_incorporation
                            ? new Date(
                                storeDetails.BusinessDetails
                                  .date_of_incorporation,
                              )
                                .toISOString()
                                .slice(0, 10)
                            : ""
                        }
                      />
                      <div className="text-left text-small text-muted input-hint">
                        Select the official company incorporation date
                      </div>

                      <div className="text-left text-small color_red inputErrorSection">
                        {renderErrorMessage("date_of_incorporation")}
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group">
                      <label>PAN Number</label>
                      <input
                        type="text"
                        name="store_pan_number"
                        onChange={(e) =>
                          handleBusinessDetails(
                            "BusinessDetails",
                            "store_pan_number",
                            e.target.value,
                          )
                        }
                        onBlur={() =>
                          handleBlur(
                            "BusinessDetails",
                            "store_pan_number",
                            storeDetails.BusinessDetails.store_pan_number,
                          )
                        }
                        value={
                          storeDetails.BusinessDetails.store_pan_number || ""
                        }
                      />
                      <div className="text-left text-small text-muted input-hint">
                        Enter 10-character alphanumeric PAN (e.g., ABCDE1234F)
                      </div>

                      <div className="text-left text-small color_red inputErrorSection">
                        {renderErrorMessage("store_pan_number")}
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group">
                      <label>Name as Per PAN</label>
                      <input
                        type="text"
                        name="name_as_per_pan"
                        onChange={(e) =>
                          handleBusinessDetails(
                            "BusinessDetails",
                            "name_as_per_pan",
                            e.target.value,
                          )
                        }
                        onBlur={() =>
                          handleBlur(
                            "BusinessDetails",
                            "name_as_per_pan",
                            storeDetails.BusinessDetails.name_as_per_pan,
                          )
                        }
                        value={
                          storeDetails.BusinessDetails.name_as_per_pan || ""
                        }
                      />
                      <div className="text-left text-small text-muted input-hint">
                        Ensure this matches exactly with PAN records
                      </div>

                      <div className="text-left text-small color_red inputErrorSection">
                        {renderErrorMessage("name_as_per_pan")}
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group">
                      <label>GST Number</label>
                      <input
                        type="text"
                        name="store_gst_number"
                        onChange={(e) =>
                          handleBusinessDetails(
                            "BusinessDetails",
                            "store_gst_number",
                            e.target.value,
                          )
                        }
                        onBlur={() =>
                          handleBlur(
                            "BusinessDetails",
                            "store_gst_number",
                            storeDetails.BusinessDetails.store_gst_number,
                          )
                        }
                        value={
                          storeDetails.BusinessDetails.store_gst_number || ""
                        }
                      />
                      <div className="text-left text-small text-muted input-hint">
                        15-character GSTIN (e.g., 22ABCDE1234F1Z5)
                      </div>

                      <div className="text-left text-small color_red inputErrorSection">
                        {renderErrorMessage("store_gst_number")}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        );

      case "BankDetails":
        return (
          <>
            {storeDetails["BankDetails"] && (
              <div className="profile-section">
                <div className="row">
                  <div className="col-12">
                    <h5 className="storetitle pt-2">Bank Details</h5>
                  </div>
                </div>
                <div className="row borderup">
                  <div className="col-3">
                    <div className="form-group">
                      <label>Beneficiary Name</label>
                      <input
                        type="text"
                        name="beneficiary_name"
                        onChange={(e) =>
                          handleBankDetails(
                            "BankDetails",
                            "beneficiary_name",
                            e.target.value,
                          )
                        }
                        onBlur={() =>
                          handleBlur(
                            "BankDetails",
                            "beneficiary_name",
                            storeDetails.BankDetails.store_bank_details
                              .beneficiary_name,
                          )
                        }
                        value={
                          storeDetails.BankDetails?.store_bank_details
                            ?.beneficiary_name || ""
                        }
                      />
                      <div className="input-hint">
                        Full name of the account holder
                      </div>

                      <div className="text-left text-small color_red inputErrorSection">
                        {renderErrorMessage("beneficiary_name")}
                      </div>
                    </div>
                  </div>

                  <div className="col-3">
                    <div className="form-group">
                      <label>Account Number</label>
                      <input
                        type="text"
                        name="settlement_bank_account_no"
                        onChange={(e) =>
                          handleBankDetails(
                            "BankDetails",
                            "settlement_bank_account_no",
                            e.target.value,
                          )
                        }
                        onBlur={() =>
                          handleBlur(
                            "BankDetails",
                            "settlement_bank_account_no",
                            storeDetails.BankDetails.store_bank_details
                              .settlement_bank_account_no,
                          )
                        }
                        value={
                          storeDetails.BankDetails?.store_bank_details
                            ?.settlement_bank_account_no || ""
                        }
                      />
                      <div className="input-hint">
                        Must be numeric and between 9–18 digits
                      </div>
                      <div className="text-left text-small color_red inputErrorSection">
                        {renderErrorMessage("settlement_bank_account_no")}
                      </div>
                    </div>
                  </div>

                  <div className="col-3">
                    <div className="form-group">
                      <label>IFSC Code</label>
                      <input
                        type="text"
                        name="settlement_ifsc_code"
                        onChange={(e) =>
                          handleBankDetails(
                            "BankDetails",
                            "settlement_ifsc_code",
                            e.target.value,
                          )
                        }
                        onBlur={() =>
                          handleBlur(
                            "BankDetails",
                            "settlement_ifsc_code",
                            storeDetails.BankDetails.store_bank_details
                              .settlement_ifsc_code,
                          )
                        }
                        value={
                          storeDetails.BankDetails?.store_bank_details
                            ?.settlement_ifsc_code || ""
                        }
                      />
                      <div className="input-hint">
                        e.g., SBIN0001234 (4 letters + 7 digits)
                      </div>
                      <div className="text-left text-small color_red inputErrorSection">
                        {renderErrorMessage("settlement_ifsc_code")}
                      </div>
                    </div>
                  </div>

                  <div className="col-3">
                    <div className="form-group">
                      <label>Bank Name</label>
                      <input
                        type="text"
                        name="bank_name"
                        onChange={(e) =>
                          handleBankDetails(
                            "BankDetails",
                            "bank_name",
                            e.target.value,
                          )
                        }
                        onBlur={() =>
                          handleBlur(
                            "BankDetails",
                            "bank_name",
                            storeDetails.BankDetails.store_bank_details
                              .bank_name,
                          )
                        }
                        value={
                          storeDetails.BankDetails?.store_bank_details
                            ?.bank_name || ""
                        }
                      />
                      <div className="input-hint">
                        Full name of the bank (e.g.,SBI or State Bank of India)
                      </div>
                      <div className="text-left text-small color_red inputErrorSection">
                        {renderErrorMessage("bank_name")}
                      </div>
                    </div>
                  </div>

                  <div className="col-3">
                    <div className="form-group">
                      <label>Branch</label>
                      <input
                        type="text"
                        name="branch_name"
                        onChange={(e) =>
                          handleBankDetails(
                            "BankDetails",
                            "branch_name",
                            e.target.value,
                          )
                        }
                        onBlur={() =>
                          handleBlur(
                            "BankDetails",
                            "branch_name",
                            storeDetails.BankDetails.store_bank_details
                              .branch_name,
                          )
                        }
                        value={
                          storeDetails.BankDetails?.store_bank_details
                            ?.branch_name || ""
                        }
                      />
                      <div className="input-hint">
                        e.g., Andheri East Branch
                      </div>
                      <div className="text-left text-small color_red inputErrorSection">
                        {renderErrorMessage("branch_name")}
                      </div>
                    </div>
                  </div>

                  <div className="col-3">
                    <div className="form-group">
                      <label>Settlement Window Days</label>
                      <input
                        type="text"
                        name="settlement_bank_account_no"
                        onChange={(e) =>
                          handleBankDetails(
                            "BankDetails",
                            "settlement_window",
                            e.target.value,
                          )
                        }
                        onBlur={() =>
                          handleBlur(
                            "BankDetails",
                            "settlement_window",
                            storeDetails.BankDetails.store_bank_details
                              .settlement_window,
                          )
                        }
                        value={
                          storeDetails.BankDetails?.store_bank_details
                            ?.settlement_window || null
                        }
                      />
                      <div className="input-hint">Must be numeric digit.</div>
                      <div className="text-left text-small color_red inputErrorSection">
                        {renderErrorMessage("settlement_window")}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        );

      case "CustomerSupport":
        return (
          <>
            {storeDetails["CustomerSupport"] && (
              <div className="profile-section">
                {/* Header */}
                <div className="row">
                  <div className="col-12">
                    <h5 className="storetitle pt-2">Customer Support</h5>
                  </div>
                </div>

                {/* Support Email and Contact No */}
                <div className="row borderup">
                  <div className="col-3">
                    <div className="form-group">
                      <label>Email</label>
                      <input
                        type="text"
                        name="support_email"
                        onChange={(e) =>
                          handleCustomerSupport(
                            "CustomerSupport",
                            "support_email",
                            e.target.value,
                          )
                        }
                        onBlur={() =>
                          handleBlur(
                            "CustomerSupport",
                            "support_email",
                            storeDetails.CustomerSupport?.support_email,
                          )
                        }
                        value={
                          storeDetails.CustomerSupport?.support_email || ""
                        }
                      />
                      <div className="input-hint">
                        Please enter a valid email address (e.g.,
                        support@example.com).
                      </div>
                      <div className="text-left text-small color_red inputErrorSection">
                        {renderErrorMessage("support_email")}
                      </div>
                    </div>
                  </div>

                  <div className="col-3">
                    <div className="form-group">
                      <label>Contact No</label>
                      <input
                        type="text"
                        name="support_phone_number"
                        onChange={(e) =>
                          handleCustomerSupport(
                            "CustomerSupport",
                            "support_phone_number",
                            e.target.value,
                          )
                        }
                        onBlur={() =>
                          handleBlur(
                            "CustomerSupport",
                            "support_phone_number",
                            storeDetails.CustomerSupport?.support_phone_number,
                          )
                        }
                        value={
                          storeDetails.CustomerSupport?.support_phone_number ||
                          ""
                        }
                      />
                      <div className="input-hint">
                        Enter a valid 10 digit contact number(e.g., 9234567890).
                      </div>
                      <div className="text-left text-small color_red inputErrorSection">
                        {renderErrorMessage("support_phone_number")}
                      </div>
                    </div>
                  </div>
                </div>

                {/* GRO Information */}
                <h6 className="storeinfo" style={{ marginTop: "15px" }}>
                  Grievance Redressal Officer (GRO) Information
                </h6>
                <div
                  className="storeimg"
                  style={{
                    backgroundColor: "white",
                    padding: "10px",
                    border: "1px solid #ccc",
                  }}
                >
                  <div className="row">
                    {/* GRO Active Toggle */}
                    <div className="col-2">
                      <div className="form-group">
                        <label>GRO Active/In Active</label>
                        <span
                          className="toggleBtn"
                          onClick={() => {
                            const updatedStoreDetails = {
                              ...storeDetails,
                              CustomerSupport: {
                                ...storeDetails.CustomerSupport,
                                gro_active:
                                  !storeDetails.CustomerSupport.gro_active,
                              },
                            };
                            setStoreDetails(updatedStoreDetails);
                            handleBlur(
                              "CustomerSupport",
                              "gro_active",
                              updatedStoreDetails.CustomerSupport.gro_active,
                            );
                          }}
                        >
                          {storeDetails.CustomerSupport?.gro_active ? (
                            <FaToggleOn size={40} color={"green"} />
                          ) : (
                            <FaToggleOff size={40} color={"#cd3e3e"} />
                          )}
                        </span>
                        <div className="input-hint">
                          Toggle to activate or deactivate the GRO information.
                        </div>
                        <div className="text-left text-small color_red inputErrorSection">
                          {renderErrorMessage("gro_active")}
                        </div>
                      </div>
                    </div>

                    {/* GRO Name */}
                    <div className="col-2">
                      <div className="form-group">
                        <label>Name</label>
                        <input
                          type="text"
                          name="gro_name"
                          onChange={(e) =>
                            handleCustomerSupport(
                              "CustomerSupport",
                              "gro_name",
                              e.target.value,
                            )
                          }
                          onBlur={() =>
                            handleBlur(
                              "CustomerSupport",
                              "gro_name",
                              storeDetails.CustomerSupport?.gro_name,
                            )
                          }
                          value={storeDetails.CustomerSupport?.gro_name || ""}
                        />
                        <div className="input-hint">
                          Enter the full name of the Grievance Redressal
                          Officer.
                        </div>
                        <div className="text-left text-small color_red inputErrorSection">
                          {renderErrorMessage("gro_name")}
                        </div>
                      </div>
                    </div>

                    {/* GRO Contact No */}
                    <div className="col-2">
                      <div className="form-group">
                        <label>Contact No</label>
                        <input
                          type="text"
                          name="gro_phone"
                          onChange={(e) =>
                            handleCustomerSupport(
                              "CustomerSupport",
                              "gro_phone",
                              e.target.value,
                            )
                          }
                          onBlur={() =>
                            handleBlur(
                              "CustomerSupport",
                              "gro_phone",
                              storeDetails.CustomerSupport?.gro_phone,
                            )
                          }
                          value={storeDetails.CustomerSupport?.gro_phone || ""}
                        />
                        <div className="input-hint">
                          Enter a valid contact number for the GRO (e.g.,
                          +91-9876543210).
                        </div>
                        <div className="text-left text-small color_red inputErrorSection">
                          {renderErrorMessage("gro_phone")}
                        </div>
                      </div>
                    </div>

                    {/* GRO Email */}
                    <div className="col-3">
                      <div className="form-group">
                        <label>Email</label>
                        <input
                          type="text"
                          name="gro_email"
                          onChange={(e) =>
                            handleCustomerSupport(
                              "CustomerSupport",
                              "gro_email",
                              e.target.value,
                            )
                          }
                          onBlur={() =>
                            handleBlur(
                              "CustomerSupport",
                              "gro_email",
                              storeDetails.CustomerSupport?.gro_email,
                            )
                          }
                          value={storeDetails.CustomerSupport?.gro_email || ""}
                        />
                        <div className="input-hint">
                          Please enter a valid email address for the GRO (e.g.,
                          gro@example.com).
                        </div>
                        <div className="text-left text-small color_red inputErrorSection">
                          {renderErrorMessage("gro_email")}
                        </div>
                      </div>
                    </div>
                    <div className="col-3 form-group">
                      <label>Profile Image</label>
                      <div className="profileImageContainer">
                        {storeDetails.CustomerSupport?.gro_profile_image ? (
                          <div className="profileImagePreview">
                            <img
                              src={
                                storeDetails.CustomerSupport
                                  .gro_profile_image instanceof File
                                  ? URL.createObjectURL(
                                      storeDetails.CustomerSupport
                                        .gro_profile_image,
                                    )
                                  : storeDetails.CustomerSupport
                                      .gro_profile_image
                              }
                              alt="GRO Profile"
                              className="profileImage"
                              onLoad={(e) => {
                                if (
                                  storeDetails.CustomerSupport
                                    .gro_profile_image instanceof File
                                ) {
                                  URL.revokeObjectURL(e.target.src);
                                }
                              }}
                            />
                            <div className="profileImageEditAction">
                              <FiEdit
                                title="Edit Profile Image"
                                style={{
                                  cursor: "pointer",
                                  fontSize: "20px",
                                  color: "black",
                                }}
                                onClick={() =>
                                  document
                                    .getElementById("groProfileImageInput")
                                    .click()
                                }
                              />
                            </div>
                          </div>
                        ) : (
                          <div
                            className="placeholderProfileImage"
                            onClick={() =>
                              document
                                .getElementById("groProfileImageInput")
                                .click()
                            }
                          >
                            <FiUpload
                              style={{
                                cursor: "pointer",
                                fontSize: "24px",
                                color: "#007bff",
                              }}
                            />
                          </div>
                        )}

                        <input
                          type="file"
                          name="gro_profile_image"
                          id="groProfileImageInput"
                          accept="image/jpeg, image/png, image/jpg, image/webp"
                          style={{ display: "none" }}
                          onChange={(e) =>
                            handleGroProfileImageChange(e.target.files[0])
                          }
                        />
                      </div>

                      <div className="input-hint">
                        Upload a valid profile image for the GRO.
                      </div>
                      <div className="text-left text-small color_red inputErrorSection">
                        {renderErrorMessage("gro_profile_image")}
                      </div>
                    </div>
                  </div>
                  <div className="text-left text-small color_red inputErrorSection">
                    {renderErrorMessage("gro_profile_image")}
                  </div>
                </div>

                {/* GRO Address */}
                <br />
                <h6>Address</h6>

                <div
                  className="row"
                  style={{
                    backgroundColor: "white",
                    padding: "10px",
                    border: "1px solid #ccc",
                    margin: "0",
                  }}
                >
                  {[
                    { label: "Locality", name: "locality" },
                    { label: "Street", name: "street" },
                    { label: "City", name: "city" },
                    { label: "State", name: "state" },
                    { label: "Pincode", name: "area_code" },
                    { label: "Latitude", name: "latitude" },
                    { label: "Longitude", name: "longitude" },
                  ].map((field) => (
                    <div className="col-3" key={field.name}>
                      <div className="form-group">
                        <label>{field.label}</label>
                        <input
                          type="text"
                          name={field.name}
                          onChange={(e) =>
                            handleCustomerSupport(
                              "CustomerSupport",
                              `gro_address.${field.name}`,
                              e.target.value,
                            )
                          }
                          onBlur={() =>
                            handleBlur(
                              "CustomerSupport",
                              `gro_address.${field.name}`,
                              storeDetails.CustomerSupport?.gro_address?.[
                                field.name
                              ],
                            )
                          }
                          value={
                            storeDetails.CustomerSupport?.gro_address?.[
                              field.name
                            ] || ""
                          }
                        />
                        <div className="text-left text-small color_red inputErrorSection">
                          {renderErrorMessage(`gro_address.${field.name}`)}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </>
        );

      default:
        return <div>Select a tab to see its content.</div>;
    }
  };

  return canViewSettings || canEditSettings ? (
    <div className="row px-2">
      <div className="settings-profile-container">
        <div className="settings-header">
          <h2>Settings</h2>
        </div>
        <div className="settings-content">
          <div className="settings-sidebar">
            <ul>
              {[
                "StoreDetails",
                "StoreSettings",
                "ServiceabilityAndDeliveryCharges",
                "BusinessDetails",
                "BankDetails",
                "CustomerSupport",
              ].map((tab) => {
                const isDisabled = isTabDisabled(tab);
                return (
                  <li
                    key={tab}
                    className={`${activeTab === tab ? "active" : ""} ${
                      isDisabled ? "disabled" : ""
                    }`}
                    onClick={() => {
                      if (!isDisabled) {
                        setActiveTab(tab);
                      } else {
                        addToast(
                          `${formatTabName(
                            tab,
                          )} is disabled until Store Details is completed.`,
                          {
                            appearance: "warning",
                          },
                        );
                      }
                    }}
                  >
                    {formatTabName(tab)}
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="settings-main">
            {renderTabContent()}
            <div className="savebtn">
              <button
                className="save-btn"
                onClick={() => {
                  if (activeTab) {
                    handleFormSubmit(activeTab);
                  } else {
                    addToast("No active tab selected. Please select a tab.", {
                      appearance: "warning",
                    });
                  }
                }}
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <UnAuthorized />
  );
};

export default StoreView;
